import axios from 'services/index';
import config from 'config/config';

/**
 * Get the team members of a vet to display in manage practice page
 * 
 * @returns {Promise<import('axios').AxiosResponse>}
 * @throws {{ status?: number, detail?: string, source?: string, raw: any }}
 */
export async function getTeamMembers() {
    try {
    	return await axios.get(`${config.API_URL}portal/vet/contacts`);
  	} catch (err) {
    	const resp = err?.response;
    	const data = resp?.data;

    	const normalized = {
      		status: resp?.status,
      		detail: data?.errors?.detail ?? data?.message ?? err?.message,
      		source: data?.errors?.source,
      		raw: err,
    	};

    	// Throw a plain object so upstream code can read `detail` directly
    	throw normalized;
  	}
}

/**
 * Get the team members of a vet to display in manage practice page
 * @param {Object} vetId The vetId to retrieve its team members
 */
export async function addTeamMember(data) {
    // Includes the auth token and the brand data in the request headers
    return axios.post(`${config.API_URL}portal/contact`, data);
}

/**
 * Get the team member details
 * @param {Object} memberId - Known as contact id in Sugar API
 */
export async function getMember(memberId) {
    // Includes the auth token and the brand data in the request headers
    return axios.get(`${config.API_URL}portal/contact/${memberId}`);
}

/**
 * Updates the team member details
 * @param {Object} memberId - Known as contact id in Sugar API
 */
export async function updateMember(memberId, data) {
    // Includes the auth token and the brand data in the request headers
    return axios.post(`${config.API_URL}portal/contact/${memberId}`, data);
}
